import { render, staticRenderFns } from "./pay-account-item.vue?vue&type=template&id=29873ec8"
import script from "./pay-account-item.vue?vue&type=script&lang=js"
export * from "./pay-account-item.vue?vue&type=script&lang=js"
import style0 from "./pay-account-item.vue?vue&type=style&index=0&id=29873ec8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports